module.exports = __webpack_public_path__ + "media/Electric-driving-ec-phev.4b6b34c2.mp4";